// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

// Font Awesome setup ✅
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faUser,
    faPhone,
    faMobileScreen,        // v6 replacement for "mobile"/"mobile-alt"
    faUpRightFromSquare,
    faLocationDot, faEnvelope,         // v6 replacement for "map-marker-alt"/"location"
} from '@fortawesome/free-solid-svg-icons'

// Add only the icons you actually use
library.add(faEnvelope, faUser, faPhone, faMobileScreen, faUpRightFromSquare, faLocationDot)

// A2HS
import AddToHomescreen from '@owliehq/vue-addtohomescreen'

/* global __APP_VERSION__ */

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app
    // register FA component (your alias)
    .component('f-a-i', FontAwesomeIcon)
    .use(router)
    .use(pinia)
    .use(vuetify)
    .use(AddToHomescreen, { buttonColor: '#f57c00' })

console.info('TZAPP version:', __APP_VERSION__)

app.mount('#app')
